var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUtilityBill16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.994 6H2.007c-.373 0-.673.3-.673.673v6.654c0 .373.3.673.673.673h11.987c.373 0 .673-.3.673-.673V6.673c0-.373-.3-.673-.673-.673Z",
  fill: "#A3D3FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m13.667 8.667-5.666 2.666-5.667-2.666v-6c0-.367.3-.667.667-.667h10c.366 0 .666.3.666.667v6Z",
  fill: "#2D91FF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.067c.144 0 .272.092.317.228l1.017 3.05 1.017-3.05a.334.334 0 0 1 .633.21l-.396 1.187h.746a.333.333 0 1 1 0 .666h-.968L9.65 8.506a.334.334 0 0 1-.632 0L8 5.455l-1.017 3.05a.334.334 0 0 1-.633 0l-.716-2.147h-.968a.334.334 0 0 1 0-.666h.746l-.395-1.186a.334.334 0 0 1 .632-.211l1.017 3.05 1.017-3.05.021-.05a.334.334 0 0 1 .296-.178Z",
  fill: "#fff"
})));
export default SvgIcUtilityBill16X16;